import { Injectable, signal } from '@angular/core';
import { STRINGS } from './strings';

export type Lang = 'en' | 'es';

/**
 * English / Spanish for the sign-up, setup and driver join pages. The choice is kept in this browser
 * (localStorage "paq.lang"); the first time it follows the browser's language.
 */
@Injectable({ providedIn: 'root' })
export class I18nService {
  readonly lang = signal<Lang>(I18nService.initial());

  private static initial(): Lang {
    try {
      const saved = localStorage.getItem('paq.lang');
      if (saved === 'en' || saved === 'es') return saved;
    } catch { /* storage blocked */ }
    const nav = (typeof navigator !== 'undefined' ? navigator.language : '') || '';
    return nav.toLowerCase().startsWith('es') ? 'es' : 'en';
  }

  set(lang: Lang): void {
    this.lang.set(lang);
    try { localStorage.setItem('paq.lang', lang); } catch { /* storage blocked */ }
    try { document.documentElement.lang = lang; } catch { /* no document */ }
  }

  /** Text for a key in the current language, with {name} replaced from params. Unknown keys come back as the key. */
  t(key: string, params?: Record<string, string | number | null | undefined>): string {
    const entry = STRINGS[key];
    let text = entry ? (entry[this.lang()] ?? entry.en) : key;
    if (params) {
      for (const [k, v] of Object.entries(params)) {
        text = text.split(`{${k}}`).join(v === null || v === undefined ? '' : String(v));
      }
    }
    return text;
  }
}
